import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from "../../../components/GridHeader";
import GridConfig from "./gridConfig";
import styles from "../../../common/GridStyles";
import GridTabHeader from '../../../components/GridTabHeader';
import { getExportFilename } from "../../../utils";
import { SHIPMENT_SELECTION_STEPS } from "../../../constants";
class IBBillsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ""
    };
    this.gridConfig = new GridConfig({
      userConfig: this.props.userProfile?.columnPref,
      columnConfig: this.props.configJSON?.gridColumnConfig,
      terminal: this.props.userProfile?.terminal.code,
    });
    this.gridApi = null;
  }

  componentDidMount() {
    this.props.glEventHub.on("IBBillsGrid", this.onSearchTextChanged);
  }

  componentWillUnmount() {
    this.props.glEventHub.off("IBBillsGrid", this.onSearchTextChanged);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.selectAll = this.selectAll;
  };

  selectAll = (selected, selectedTrailers) => {
    this.props.updateAllIBBills(selected, selectedTrailers)
  }

  onCellClicked = (params) => {
    const column = params.colDef?.colId;
    if (['totalBillsDueToday', 'totalBills', 'svc'].includes(column)) {
      this.props.showDueBills(params.data);
      return;
    }
    if (column === "batchCheckbox") {
      this.gridApi.refreshCells({ columns: ["batchCheckbox"] });
      this.props.updateSelectedIBBill(params.data, !params.data.isSelected);
    }
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    const totalTrailers = filteredData.filter(data=>data.trailerNumber).length
    return [
      {
        label: totalTrailers + " Linehaul Trailers",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, rowData, tabList, onTabChange} = this.props;
    const exportFileName = getExportFilename({
      tabId: this.props.tabId,
      sectionTitle: 'IB Bills',
      tabList
    });
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridTabHeader
          tabList={tabList}
          handleTabChange={onTabChange}
          tabId={this.props.tabId}
          gridName="Bill"
          handleRefresh={this.props.handleRefresh}
          headerId={SHIPMENT_SELECTION_STEPS.IB_BILLS}
        />
        <GridHeader
          title="IB Bills"
          headerId="IBBillsGrid"
          glEventHub={this.props.glEventHub}
          showIBETACutoff
          onIBCutoffChanged={this.props.onIBCutoffChanged}
          ibEtaCutOff={this.props.ibEtaCutOff}
          gridApi={this.gridApi}
          userProfile={this.props.userProfile }
          exportFileName={exportFileName}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          rowData={rowData}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.id}
          quickFilterText={this.state.searchText}
          suppressRowClickSelection
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          rowClassRules={config.rowClassRules}
          onCellClicked={this.onCellClicked}
          onGridReady={this.onGridReady}
          showErrorMessage={this.props.gridErrorMessage}
          includeHiddenColumnsInQuickFilter={true}
        />
      </div>
    );
  }
}

export default withStyles(styles)(IBBillsGrid);
